<!--督办人弹框搜索-->
<template>
  <div>
    <el-input type="text"
              autocomplete="off"
              v-model="handleName"
              @focus="showPop = true"
              :clearable="true"
    >
      <i slot="suffix" class="el-input__icon el-icon-search"
         @click="showPop = true"></i>
    </el-input>

    <!-- /督办人弹框 -->
    <duDialog v-if="showPop"
              @commitAdminRow="commitAdminRow"
              :visiable.sync="showPop"
              multi="true"
    />
  </div>
</template>

<script>
import duDialog from "@/views/dialogCommon/adminDialog";

export default {
  name: 'handlePopSearch',
  props: ['handleId', "handleName"],
  components: {duDialog},
  data() {
    return {
      showPop: false,
    }
  },

  watch: {
    handleName: {
      handler(newVal) {
        if (newVal == null || newVal == '' || newVal == undefined) {
          this.$emit('update:handleId', null)
          this.$emit('update:handleName', null)
          this.$emit('valueChange')
        }
      },
      deep: true,
      immediate: false,
    }
  },


  methods: {
    // showPopFunc() {
    //   if (this.editable) {
    //     this.showPop = true
    //   } else {
    //     this.showPop = false
    //   }
    // },

    // 网点弹框选中
    commitAdminRow(data, type) {
      console.log('选中的数据', data, type)
      this.handleName = data.username
      this.$emit('update:handleId', data.id)
      this.$emit('update:handleName', this.handleName)
    },
  },
};
</script>

<style scoped lang="scss">

</style>
